module.exports = __webpack_public_path__ + "static/img/icon-menu5.491a9a64.svg";